((Drupal) => {
  Drupal.behaviors.kafBasicPage = {
    attach: (context) => {
      const lists = document.querySelector('.page-node-type-page .page-content .region-content ul');

      if (!lists) {
        return;
      }

      // classes
      const classes = {
        hasLink: 'has-link',
      }

      const listsItem = lists.querySelectorAll('li > a');

      const listLinks = () => {
        listsItem.forEach((el, i) => {
          el.parentNode.classList.add(classes.hasLink);
        });
      }

      listLinks();
    }
  };
})(Drupal);
